import dynamic from "next/dynamic";
import Head from "next/head";
import React, { useEffect, useState } from "react";

import NativeAuthCaptcha from "~/components/forms/NativeAuthCaptcha";
import settings from "~/settings";
import {
  isExactNativeAuthCaptchaLocation,
  parseNativeAuthCaptchaUrl,
} from "~/utils/nativeAuthCaptcha";

// Keep the generic verification graph out of the native WebView bundle. The
// native route must contain only the dedicated Aliyun auth CAPTCHA bridge.
const GenericVerificationPage = dynamic(
  () => import("~/components/verification/GenericVerificationPage"),
  { ssr: true }
);

const NativeAuthVerificationPage = ({ nonce }) => {
  const getLocationValidity = () =>
    typeof window === "undefined" ||
    isExactNativeAuthCaptchaLocation(
      window.location.href,
      nonce,
      settings.appUrl
    );
  const [locationIsExact, setLocationIsExact] = useState(getLocationValidity);

  useEffect(() => {
    const revalidate = () => setLocationIsExact(getLocationValidity());
    window.addEventListener("hashchange", revalidate);
    window.addEventListener("popstate", revalidate);
    return () => {
      window.removeEventListener("hashchange", revalidate);
      window.removeEventListener("popstate", revalidate);
    };
  }, [nonce]);

  return (
    <>
      <Head>
        <meta name="referrer" content="no-referrer" />
      </Head>
      {locationIsExact ? (
        <main
          aria-label="人机验证"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <NativeAuthCaptcha nonce={nonce} trustedOrigin={settings.appUrl} />
        </main>
      ) : (
        <main aria-label="人机验证失败" style={{ padding: 24 }}>
          原生验证请求无效，请返回后重试
        </main>
      )}
    </>
  );
};

const getRawVerificationUrl = (ctx) =>
  ctx.asPath || ctx.req?.url || ctx.resolvedUrl || "/verification";

export const getVerificationPageProps = (ctx) => {
  const nativeAuthCaptcha = parseNativeAuthCaptchaUrl(getRawVerificationUrl(ctx));
  const { redirect } = ctx.query || {};

  return {
    redirect: nativeAuthCaptcha || !redirect ? null : decodeURIComponent(redirect),
    nativeAuthCaptcha,
  };
};

const VerificationPage = ({ redirect, nativeAuthCaptcha }) => {
  if (nativeAuthCaptcha) {
    return <NativeAuthVerificationPage nonce={nativeAuthCaptcha.nonce} />;
  }

  return <GenericVerificationPage redirect={redirect} />;
};

VerificationPage.requireUser = () => false;

VerificationPage.getInitialProps = async (ctx) => getVerificationPageProps(ctx);

export default VerificationPage;
